import { graphql, useStaticQuery } from 'gatsby';

import { useFlatten } from './use-flatten';
import { getProperty } from 'utils';

export const useStaticNews = () => {
	const results = useStaticQuery(query) || {};
	const key = 'squidex.findNewsSingleton';

	return useFlatten(getProperty(results, key) || {});
};

const query = graphql`
	query useNewsQuery {
		squidex {
			findNewsSingleton {
				id
				data {
					seo {
						de {
							title
							description
						}
					}

					archive {
						de {
							backgroundImage {
								metadata
								localFile {
									publicURL
								}
								...SquidexLocalFileProps
							}
							title
							latestText
							olderText
						}
					}

					article {
						de {
							furtherImages
						}
					}
				}
			}
		}
	}
`;
